import {
    Grid,
    Typography,
} from '@mui/material';

import OnBoardingLayout from '../../../../theme/templates/on-boarding';
import { Link } from '@mui/material';
import ButtonHome from '../../../components/button-home';

const HelpAndSupportPage = () => {

    return (
        <OnBoardingLayout>
            <ButtonHome />
            <Grid
                sx={{
                    maxWidth: '90%',
                    width: '500px',
                    mb: 2,
                    mx: 4,
                    py: 2,
                    px: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                }}
                item
            >
                <Typography
                    component="h1"
                    variant="h3"
                    sx={{
                        mb: 8,
                        width: '100%',
                        textAlign: 'center',
                    }}
                >
                    Help & Support
                </Typography>
                <Typography
                    component="p"
                    variant="body1"
                    sx={{
                        mb: 2,
                    }}
                >
                    Hi, how can we help?
                </Typography>
                <Typography
                    component="p"
                    variant="body1"
                    sx={{
                        mb: 2,
                    }}
                >
                    Have questions or need to report an issue with a CinemaHive product or service? We've got you covered.
                </Typography>
                <Typography
                    component="p"
                    variant="body1"
                    sx={{
                        mb: 2,
                    }}
                >
                    Email hello@cinemahive.com and we will reply in less than 24 hours.
                </Typography>
            </Grid>
        </OnBoardingLayout>
    )
};

export default HelpAndSupportPage;
